import { LogLevel } from '@amplitude/analytics-types';
import { logEventProperties, logUserProperties, writeLog } from './log';
import { remapCamelToTitleCase, remapSnakeToTitleCase } from './namingMapper';
const name = 'gaToAmpltudeNaming';
const type = 'enrichment';
let debug = false;
let remapConfig = {
  eventTypes: {},
  eventProperties: {}
};
const setup = async function (config) {
  /* istanbul ignore next */
  debug = config.logLevel === LogLevel.Debug;
};
const execute = async function (event) {
  var _event$user_propertie;
  if (event.event_type === '$exposure') {
    // We never want to modify exposure events.
    return event;
  }
  const log = {};
  const originalEventType = event.event_type;
  const remappedEventType = remapEventType(event.event_type);
  event.event_type = remappedEventType;
  /* istanbul ignore next */
  if (debug && originalEventType !== remappedEventType) {
    if (debug) {
      log.event_type = `${originalEventType}`;
    }
  }

  // When user properties are passed on a track event.
  if (event.user_properties) {
    const original = event.user_properties;
    const mapped = remapPropertyCasing(original);
    event.user_properties = mapped;
    logUserProperties(debug, log, original, mapped);
  }

  // When user properties are passed on an identify event.
  if ((_event$user_propertie = event.user_properties) !== null && _event$user_propertie !== void 0 && _event$user_propertie.$set) {
    const original = event.user_properties.$set;
    const mapped = remapPropertyCasing(original);
    event.user_properties.$set = mapped;
    logUserProperties(debug, log, original, mapped);
  }
  if (event.event_properties) {
    const original = event.event_properties;
    const mapped = remapPropertyCasing(original);
    event.event_properties = mapped;
    logEventProperties(debug, log, original, mapped);
  }

  /* istanbul ignore next */
  if (debug) {
    writeLog(log, 'GA to Amplitude remapping occurred', remapEventType, remapPropertyName);
  }
  return event;
};
const gaToAmplitudeNamingPluginConstructor = maps => {
  if (maps && Object.keys(maps).length !== 0) {
    remapConfig = maps;
  }
  const plugin = {
    name,
    type,
    setup,
    execute
  };
  return plugin;
};
export default gaToAmplitudeNamingPluginConstructor;
const isRemapped = (map, itemName) => Object.values(map || {}).includes(itemName);
const remapEventType = eventType => {
  if (isRemapped(remapConfig.eventTypes, eventType)) {
    return eventType;
  }
  return remapCamelToTitleCase(eventType);
};
const remapPropertyName = propertyName => {
  if (isRemapped(remapConfig.eventProperties, propertyName)) {
    return propertyName;
  }
  return remapSnakeToTitleCase(propertyName);
};
const remapPropertyCasing = properties => {
  const eventProperties = Object.entries(properties);
  const mappedEvents = eventProperties.map(([property, value]) => [remapPropertyName(property), value]);
  return Object.fromEntries(mappedEvents);
};
//# sourceMappingURL=gaToAmplitudeNamingPlugin.js.map